// dynamically generated by buildSrc.js on postinstall
import { icon as iconam } from '@sesatheque-plugins/am/icon.js'
import { icon as iconato } from '@sesatheque-plugins/ato/icon.js'
import { icon as iconcoll_doc } from '@sesatheque-plugins/coll_doc/icon.js'
import { icon as iconecjs } from '@sesatheque-plugins/ecjs/icon.js'
import { icon as iconem } from '@sesatheque-plugins/em/icon.js'
import { icon as iconarbre } from '@sesatheque-plugins/arbre/icon.js'
import { icon as iconiep } from '@sesatheque-plugins/iep/icon.js'
import { icon as iconj3p } from '@sesatheque-plugins/j3p/icon.js'
import { icon as iconmathgraph } from '@sesatheque-plugins/mathgraph/icon.js'
import { icon as iconqcm } from '@sesatheque-plugins/qcm/icon.js'
import { icon as iconurl } from '@sesatheque-plugins/url/icon.js'

export default {
  am: iconam,
  ato: iconato,
  coll_doc: iconcoll_doc,
  ecjs: iconecjs,
  em: iconem,
  arbre: iconarbre,
  iep: iconiep,
  j3p: iconj3p,
  mathgraph: iconmathgraph,
  qcm: iconqcm,
  url: iconurl,
}